/********* START Time table for pickup selection *********/
var botanyMondayTimeTable = [
{ "timeValue": "13:00 - 13:30" },
{ "timeValue": "13:30 - 14:00" },
{ "timeValue": "14:00 - 14:30" },    
{ "timeValue": "14:30 - 15:00" },
{ "timeValue": "15:00 - 15:30" },
{ "timeValue": "15:30 - 16:00" },
{ "timeValue": "16:00 - 16:30" }, 
{ "timeValue": "16:30 - 17:00" },
{ "timeValue": "17:00 - 17:30" },
{ "timeValue": "17:30 - 18:00" },
{ "timeValue": "18:00 - 18:30" }
];

var botanyTuesdayTimeTable = [
{ "timeValue": "08:00 - 08:30" },
{ "timeValue": "08:30 - 09:30" },
{ "timeValue": "09:00 - 09:30" },
{ "timeValue": "09:30 - 10:00" },    
{ "timeValue": "10:00 - 10:30" },
{ "timeValue": "10:30 - 11:00" },
{ "timeValue": "11:00 - 11:30" }, 
{ "timeValue": "11:30 - 12:00" }
];

var brookvaleMondayTimeTable = [
{ "timeValue": "13:00 - 13:30" },
{ "timeValue": "13:30 - 14:00" },
{ "timeValue": "14:00 - 14:30" },    
{ "timeValue": "14:30 - 15:00" },
{ "timeValue": "15:00 - 15:30" },
{ "timeValue": "15:30 - 16:00" },
{ "timeValue": "16:00 - 16:30" }, 
{ "timeValue": "16:30 - 17:00" }
];

var brookvaleTuesdayTimeTable = [
{ "timeValue": "08:00 - 08:30" },
{ "timeValue": "08:30 - 09:30" },
{ "timeValue": "09:00 - 09:30" },
{ "timeValue": "09:30 - 10:00" },    
{ "timeValue": "10:00 - 10:30" },
{ "timeValue": "10:30 - 11:00" },
{ "timeValue": "11:00 - 11:30" }, 
{ "timeValue": "11:30 - 12:00" },
{ "timeValue": "12:00 - 12:30" },
{ "timeValue": "12:30 - 13:00" },
{ "timeValue": "13:00 - 13:30" },
{ "timeValue": "13:30 - 14:00" },
{ "timeValue": "14:00 - 14:30" },    
{ "timeValue": "14:30 - 15:00" },
{ "timeValue": "15:00 - 15:30" },
{ "timeValue": "15:30 - 16:00" },
{ "timeValue": "16:00 - 16:30" }, 
{ "timeValue": "16:30 - 17:00" }
];
/********* END Time table for pickup selection *********/

/********* START PICKUP SELECTION FUNCTIONS *********/
function modalInit(modalId, formId){
  $(modalId).dialog({
   autoOpen: false,  
   width: "auto",
   height: "auto",
   modal:true,
   appendTo: formId,
   dialogClass: "no-close",
   buttons: [{
    text: "OK",
    click: function() {
      $( this ).dialog( "close" );
    }
  }]
});
};

function hookChangeEvent(inputId, formId, action){
  $(inputId, formId).change(function (){
    action();
  });
};

function datePickerInit(datepickerId, timeSelectionId){
  $(datepickerId).datepicker({
    defaultDate: null,
    autoSize: true,
    dateFormat: 'dd M yy',
    minDate: 0, 
    onSelect: function(dateText, inst){
      var selectedLocation = $('input:checked, #shopping-cart').val();
      var dayOfTheWeek = $(datepickerId).datepicker('getDate').getUTCDay();
      var selector = document.getElementById('time-options');

      var timeTableToUse = getTimeTable(dayOfTheWeek, selectedLocation);

      if(timeTableToUse != null){
        $(selector).empty();
        populateSelect(selector, timeTableToUse, { value: 'timeValue', textContent: 'timeValue'});
      }
       
      $(timeSelectionId).show();
    },
    beforeShowDay: function(date) {
      var day = date.getDay();
      return [(day != 0 && day != 3 && day != 4 && day != 5 && day != 6)];
    }
  });
};


function getTimeTable(dayOfTheWeek, selectedLocation){
  if(selectedLocation.toLowerCase().indexOf("botany") >= 0 && dayOfTheWeek == 0)
    return botanyMondayTimeTable;

  if(selectedLocation.toLowerCase().indexOf("botany") >= 0 && dayOfTheWeek == 1)
    return botanyTuesdayTimeTable;

  if(selectedLocation.toLowerCase().indexOf("brookvale") >= 0 && dayOfTheWeek == 0)
    return brookvaleMondayTimeTable;

  if(selectedLocation.toLowerCase().indexOf("brookvale") >= 0 && dayOfTheWeek == 1)
    return brookvaleTuesdayTimeTable;
};

//This function uses native JavaScript. Do not pass jQuery selectors!!
function populateSelect(select, data, attrs) {
  var frag = document.createDocumentFragment();
  data.forEach(function(option) {
    var opt = document.createElement('option');
    for (var i in attrs) {
      opt[i] = option[attrs[i]];
    }
    frag.appendChild(opt);
  });
  select.appendChild(frag.cloneNode(true));
};
/********* END PICKUP SELECTION FUNCTIONS *********/

function agreeWithTermsInit(){
  $('[name="checkout"], input[name="goto_pp"], input[name="goto_gc"]').click(function() {
    if($('#agree').is(':checked')){
      $(this).submit();
    }
    else{
      $("#agree-with-terms").dialog("open");
      return false;
    }
  });   

  $( "#agree-with-terms" ).dialog({
   autoOpen: false,  
   width: 300,
   height: "auto",
   modal:true
 });
};

